import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Analytics from "@/components/Analytics";
import Home from "@/pages/Home";
import Tools from "@/pages/Tools";
import ToolDetail from "@/pages/ToolDetail";
import Models from "@/pages/Models";
import ModelDetail from "@/pages/ModelDetail";
import Comparisons from "@/pages/Comparisons";
import ComparisonDetail from "@/pages/ComparisonDetail";
import Category from "@/pages/Category";
import Article from "@/pages/Article";
import Deals from "@/pages/Deals";
import { About, Contact, PrivacyPolicy, TermsOfUse, AffiliateDisclosure, Disclaimer } from "@/pages/Static";
import Suggest from "@/pages/Suggest";
import Advertise from "@/pages/Advertise";
import Login from "@/pages/Login";
import Admin from "@/pages/Admin";
import { NotFound } from "@/pages/ToolDetail";

function ScrollTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollTop />
        <Analytics />
        <Toaster position="top-center" theme="dark" richColors />
        <Routes>
          <Route path="/" element={<Layout><Home /></Layout>} />
          <Route path="/tools" element={<Layout><Tools /></Layout>} />
          <Route path="/tools/:slug" element={<Layout><ToolDetail /></Layout>} />
          <Route path="/ai-models" element={<Layout><Models /></Layout>} />
          <Route path="/ai-models/:slug" element={<Layout><ModelDetail /></Layout>} />
          <Route path="/comparisons" element={<Layout><Comparisons /></Layout>} />
          <Route path="/comparisons/:slug" element={<Layout><ComparisonDetail /></Layout>} />
          <Route path="/deals" element={<Layout><Deals /></Layout>} />
          <Route path="/article/:slug" element={<Layout><Article /></Layout>} />
          <Route path="/ai" element={<Layout><Category cat="AI" /></Layout>} />
          <Route path="/gaming" element={<Layout><Category cat="Gaming" /></Layout>} />
          <Route path="/tech" element={<Layout><Category cat="Tech" /></Layout>} />
          <Route path="/reviews" element={<Layout><Category cat="Reviews" /></Layout>} />
          <Route path="/guides" element={<Layout><Category cat="Guides" /></Layout>} />
          <Route path="/about" element={<Layout><About /></Layout>} />
          <Route path="/privacy" element={<Layout><PrivacyPolicy /></Layout>} />
          <Route path="/privacy-policy" element={<Navigate to="/privacy" replace />} />
          <Route path="/terms" element={<Layout><TermsOfUse /></Layout>} />
          <Route path="/affiliate-disclosure" element={<Layout><AffiliateDisclosure /></Layout>} />
          <Route path="/disclaimer" element={<Layout><Disclaimer /></Layout>} />
          <Route path="/contact" element={<Layout><Contact /></Layout>} />
          <Route path="/suggest" element={<Layout><Suggest /></Layout>} />
          <Route path="/advertise" element={<Layout><Advertise /></Layout>} />
          <Route path="/login" element={<Login />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="*" element={<Layout><NotFound /></Layout>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
